<div class="wrapper">
  <mat-card>
    <mat-card-content>
      @if(isLoading$ | async) {
      <div class="loading">
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>
      } @else { @if (isTimedOut) {
      <app-mfa-fail [errorType]="MfaErrors.IS_TIMED_OUT"></app-mfa-fail>
      } @else {
      <button
        mat-icon-button
        class="close-button"
        aria-label="close"
        (click)="onDismiss()"
      >
        <mat-icon>close</mat-icon>
      </button>
      <h3>{{ 'twoFactor.title' | translate }}</h3>
      @if (anonymizedEmail$ | async; as email) {
      <p>
        {{ 'twoFactor.textEmail1' | translate: { email } }}
      </p>
      <p class="no-margin">
        {{ 'twoFactor.textEmail2' | translate }}
        @if ((millisecondsRemaining$ | async); as millisecondsRemaining) { @if
        (millisecondsRemaining > 0) {
        <span>
          {{
            'setUpTwoFactor.email.countDownTimer'
              | translate: { time: (millisecondsRemaining | date: 'mm:ss') }
          }}
        </span>
        }} @else {
        <a (click)="onResendEmail()" class="resend-link">
          {{ 'setUpTwoFactor.email.countDownResend' | translate }}
        </a>
        }
      </p>
      } @else {
      <p>{{ 'twoFactor.textApp' | translate }}</p>
      }
      <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">
        <div class="remember-user">
          <mat-checkbox color="primary" formControlName="rememberUser" (click)="onCheckboxClick()">
            <span class="bold"
              >{{ 'twoFactor.rememberUserTitle' | translate }}<br
            /></span>
            {{ 'twoFactor.rememberUserText' | translate }}
          </mat-checkbox>
        </div>
        <div class="otp-container">
          @for (control of otpControls | keyvalue; let i = $index; let isLast =
          $last; track i;) { @if (!isLast) {
          <mat-form-field class="otp-input" (click)="onFocus(i)">
            <input
              #otpInput
              matInput
              [formControlName]="control.key"
              [id]="'otp' + i"
              (input)="onInput(i, $event)"
              (keydown)="onKeyDown(i, $event)"
              (paste)="onPaste($event)"
              maxlength="1"
              autocomplete="off"
            />
          </mat-form-field>
          } }
        </div>
        @if (alertMessage$ | async; as alert) { @if (alert) {
        <mat-error>{{ 'twoFactor.mfaInvalidCodeError' | translate }}</mat-error>
        } }
      </form>
      } }
    </mat-card-content>
  </mat-card>

  <div class="footer">
    <a
      href="https://www.actabl.com/privacy-policy"
      target="_blank"
      class="link-secondary"
      >{{ 'login.privacyPolicy' | translate }}</a
    >
  </div>
</div>
